import { render } from "./AddressListPanel.vue?vue&type=template&id=631ed84c&scoped=true&ts=true"
import script from "./AddressListPanel.vue?vue&type=script&lang=ts"
export * from "./AddressListPanel.vue?vue&type=script&lang=ts"

import "./AddressListPanel.vue?vue&type=style&index=0&id=631ed84c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631ed84c"]])

export default __exports__